// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__Pbz_3","layout-body":"style_layout-body__vxjPK"};